import { Link } from "react-router-dom";
import { useEffect } from "react";
import { ArrowLeft } from "lucide-react";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { COMPANY } from "../data";

const Section = ({ title, children }) => (
  <div className="mb-10">
    <h2 className="font-serif text-2xl font-light mb-3">{title}</h2>
    <div className="space-y-3 text-foreground/75 font-light leading-relaxed">{children}</div>
  </div>
);

export default function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div data-testid="privacy-policy-page">
      <Navbar />
      <main className="max-w-3xl mx-auto px-6 md:px-12 pt-36 pb-24">
        <Link to="/" className="inline-flex items-center gap-2 text-sm uppercase tracking-wide text-muted-foreground hover:text-foreground mb-10 link-underline" data-testid="back-home">
          <ArrowLeft strokeWidth={1.4} className="w-4 h-4" /> Torna alla Home
        </Link>
        <p className="text-xs uppercase tracking-[0.35em] text-champagne mb-4">Informativa</p>
        <h1 className="font-serif font-light text-4xl sm:text-5xl tracking-tight mb-3">Privacy Policy</h1>
        <p className="text-sm text-muted-foreground mb-12">Ai sensi del Regolamento (UE) 2016/679 (GDPR) e del D.Lgs. 196/2003.</p>

        <Section title="1. Titolare del trattamento">
          <p>{COMPANY.name} — {COMPANY.address}. P. IVA {COMPANY.piva} · C.F. {COMPANY.cf}.</p>
          <p>Email: {COMPANY.email} · Tel.: {COMPANY.phone}</p>
        </Section>

        <Section title="2. Dati raccolti">
          <p>Attraverso il modulo "Contatti" raccogliamo i dati che ci fornisci volontariamente: nome e cognome, email, numero di telefono, tipologia di progetto e il contenuto del messaggio. Durante la navigazione possono inoltre essere raccolti dati tecnici (indirizzo IP, tipo di browser, dati di utilizzo) tramite cookie, secondo quanto indicato nella Cookie Policy.</p>
        </Section>

        <Section title="3. Finalità del trattamento">
          <p>I dati sono trattati per: (a) rispondere alle richieste di informazioni e preventivo; (b) gestire il rapporto precontrattuale e contrattuale; (c) adempiere a obblighi di legge; (d) previo consenso, finalità statistiche e di marketing.</p>
        </Section>

        <Section title="4. Base giuridica">
          <p>Il trattamento si fonda sul consenso dell'interessato (art. 6.1.a GDPR), sull'esecuzione di misure precontrattuali (art. 6.1.b) e sull'adempimento di obblighi legali (art. 6.1.c).</p>
        </Section>

        <Section title="5. Modalità e conservazione">
          <p>I dati sono trattati con strumenti elettronici, nel rispetto di adeguate misure di sicurezza, e conservati per il tempo necessario alle finalità indicate e agli obblighi di legge. I dati delle richieste di contatto sono conservati per il tempo necessario a gestire la richiesta e per i successivi adempimenti.</p>
        </Section>

        <Section title="6. Comunicazione dei dati">
          <p>I dati non sono diffusi e possono essere comunicati a fornitori di servizi che operano come responsabili del trattamento (es. servizi di posta elettronica e hosting), esclusivamente per le finalità sopra indicate.</p>
        </Section>

        <Section title="7. Diritti dell'interessato">
          <p>Puoi esercitare in qualsiasi momento i diritti previsti dagli artt. 15-22 GDPR: accesso, rettifica, cancellazione, limitazione, portabilità, opposizione e revoca del consenso, scrivendo a {COMPANY.email}. Hai inoltre diritto di proporre reclamo al Garante per la protezione dei dati personali.</p>
        </Section>

        <Section title="8. Modifiche">
          <p>La presente informativa può essere aggiornata nel tempo. Ti invitiamo a consultarla periodicamente. Ultimo aggiornamento: giugno 2026.</p>
        </Section>
      </main>
      <Footer />
    </div>
  );
}
